var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialogComp',{ref:"dialog"},[_c('div',{staticStyle:{"height":"500px","overflow-y":"auto"}},[_c('img',{attrs:{"src":"https://source.qunarzz.com/site/images/wns/521684400257_.pic.jpg","alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }